import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {UserService} from "../../../services/user.service";
import {AppDataService} from "../../../services/app-data.service";
import {InstagramUserBean} from "../../../beansts/instagram.user.bean";
import {EventBean} from "../../../beansts/Event";
import {CompanyBean} from "../../../beansts/company.bean";
import { TranslationService } from '../../../services/translation.service';

import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import {WalletService} from "../../../services/wallet.services";

declare let $: any;
declare var Swal : any;

@Component({
    selector : 'profile-modal',
    templateUrl:'profile-component.html',

})
export class ProfileModalComponent implements OnInit, OnDestroy{

  public processing : boolean=false;
  public tab=1;
  public date: Date = new Date();
  public gender='M'
  public kind=0;
  public settings = {
        bigBanner: true,
        timePicker: false,
        format: 'dd-MM-yyyy',
        defaultOpen: false
  }
  public phonemask = ['(', /[0-9]/, /[0-9]/, ')', /[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]
  public birthmask = [/[0-3]/, /[0-9]/, '/', /[0-1]/,/[0-9]/,'/',/[0-2]/,/[0-9]/,/[0-9]/,/[0-9]/]
  public codemask = [/[A-Za-z]/, /[A-Za-z]/, /[A-Za-z]/,/[A-Za-z]/]
  public  imageStr;

  public profileForm : FormGroup;
  public basicMobileInfoForm : FormGroup;
    public canMailChange=true;

  private user : InstagramUserBean;
  public constructor( private _router : Router,public _walletService: WalletService, public translate: TranslationService,private _auth : UserService,public _appData : AppDataService,private fb : FormBuilder, private _companyService : CompanyService) {
      this.profileForm = this.fb.group({
        userName : '',
        userEmail : '',
        userBirthdate : '',
        userDescription: '',
        userPhone: '',
        userCode:'',
        userInstagram:'',
        userLinkedIn:'',
        addressStreet:'',
        addressComplement:'',
      });

    }

    public selectLanguage(lng){
      this._appData.instagramUser.lang=lng
      this.user.lang=lng;
      this.translate.setDefaultLang(this._appData.instagramUser.lang)
      this.finalizeUpdate();
      setTimeout(()=>{
        location.reload()
      },2000)
    }

    public ngOnInit(): any {
      this.user=this._appData.instagramUser;
      this.profileForm = this.fb.group({
        userName : '',
        userEmail : '',
        userBirthdate : '',
        userDescription: '',
        userPhone: '',
        userCode:'',
        userInstagram:'',
        userLinkedIn:'',
        addressStreet:'',
        addressComplement:'',
      });
      this.basicMobileInfoForm = this.fb.group({
        userName : '',
        userEmail : '',
        userBirthdate : '',
        userDescription: '',
        userPhone: '',
        userCode:'',
        userInstagram:'',
        userLinkedIn:'',
        addressStreet:'',
        addressComplement:'',
      });
      var date=new Date();  
      let birthdate='';
      if (this.user){
        if (this.user.id) {
          this.canMailChange=false;
      }
      this.kind=this.user.kind;
      if (this.user.birthdate!=null && this.user.birthdate>0) {
          this.date=new Date(this.user.birthdate);
          let day=this.date.getDate()
          let strmonth=''
          let strday='';
          let month=this.date.getMonth()+1
          let year=this.date.getFullYear();
          if (month<10) {strmonth='0'+month} else {strmonth=month.toString();}
          if (day<10) {strday='0'+day} else {strday=day.toString();}
          birthdate=strday+'/'+strmonth+'/'+year.toString();

        }
        var male=true;
        var female=false;
        this.gender='M'

        if (this.user.sex!=null){
          if (this.user.sex.indexOf('F')==0){
            male=false;
            female=true;
            this.gender='F'
          }
        }

 
        let code=''
        if (this.user.kind==1){
          code=this.user.code;
        }

        let instagram='';
        let linkedIn='';
        if (this.user.instagram){
          instagram=this.user.instagram;
        }
        if (this.user.linkedIn){
          linkedIn=this.user.linkedIn
        }


        this.profileForm = this.fb.group({
          userName : this.user.full_name,
          userEmail : this.user.email,
          userPhone: this.user.phone,
          userBirthdate: birthdate,
          userCode: code,
          userDescription: this.user.bio,
          userCpf:this.user.cpf,
          userInstagram:instagram,
          userLinkedIn:linkedIn, 
          addressStreet:this.user.street,
          addressComplement:this.user.complement
        });
        this.basicMobileInfoForm = this.fb.group({
          userName : this.user.full_name,
          userEmail : this.user.email,
          userPhone: this.user.phone,
          userBirthdate: birthdate,
          userCode: code,
          userDescription: this.user.bio,
          userCpf:this.user.cpf,
          userInstagram:instagram,
          userLinkedIn:linkedIn, 
          addressStreet:this.user.street,
          addressComplement:this.user.complement
        });
      }
      this._walletService.getBalance(this._appData.instagramUser).subscribe(val=>{
        if (val.status==200){
          let b=val.json()
          this._appData.balance=b.value;
          if (b.value<1000){
            //Swal.fire({title:'Sem energia',text:'Sua carteira está sem fundos. Busque o banco no jogo para adicionar fundos na carteira ou transfira solanas para ela.'})
          }
        }
        else{
          //Swal.fire({title:'Sem energia',text:'Sua carteira está sem fundos. Busque o banco no jogo para adicionar fundos na carteira ou transfira solanas para ela.'})
        }
      })

    }

    public onChange (params){
      this.ngOnInit();
  };
  public transactionHistory(){
    $('#profileModal').modal('hide')
    $('#transactionHistoryModal').modal('show')
  }


public sendWalletMail(){
  this._walletService.sendWalletMail().subscribe(val=>{
    if (val.status==200){
        Swal.fire({title:this.translate.instant('SUCCESS'),text:this.translate.instant('PROFILE_COMPONENT_8')})
    }
    else{
      Swal.fire({title:this.translate.instant('FAIL'),text:this.translate.instant('PROFILE_COMPONENT_9')})

    }

  });
}
public buyLivecoins(){
  $('#profileModal').modal('hide')
  $('#cardModal').modal('show')


}
    public setTab(i){
      this.tab=i;
    }
    public setSex(sex){
      this.gender=sex;
    }
    public setKind(kind){
      this.kind=kind;
    }
    public ngOnDestroy() : any {
    }

    public isIncompleteProfile(user){
      if (!user){
        return this.translate.instant('PROFILE_COMPONENT_10');
      }
      else{
        if (!user.full_name || user.full_name.length==0){
          return this.translate.instant('PROFILE_COMPONENT_11');
        }
        if (!user.email || user.email.length==0){
          return this.translate.instant('PROFILE_COMPONENT_12');
        }
        if (!user.phone || user.phone.length==0){
          return this.translate.instant('PROFILE_COMPONENT_13');
        }
        if (!user.birthdate || user.birthdate.length==0){
          return this.translate.instant('PROFILE_COMPONENT_14');
        }
        if (!user.profile_picture || user.profile_picture==0){
          return this.translate.instant('PROFILE_COMPONENT_15');
        }
        if (!user.street || user.street==0){
          return this.translate.instant('PROFILE_COMPONENT_16');
        }
        return '';

      }
    }

    public saveProfile() : void {
      this.processing = true;


      let wasInComplete=this.isIncompleteProfile(this._appData.instagramUser);

      let form=this.profileForm;
     // if (window.innerWidth<window.innerHeight){
       // form=this.basicMobileInfoForm;
      //}
  
      let userName : string      = form.controls['userName'].value;
      let userEmail : string      = form.controls['userEmail'].value;
      let userPhone : string = form.controls['userPhone'].value;
      let birthdate:string  =form.controls['userBirthdate'].value;
      let instagram:string = form.controls['userInstagram'].value;
      let linkedIn:string = form.controls['userLinkedIn'].value;
      let bio:string = form.controls['userDescription'].value;






      this.user.full_name=userName;
      this.user.email=userEmail;
      this.user.phone=userPhone;
      this.user.bio=bio;


      if (!userName || userName.length==0){
        Swal.fire({
          title: this.translate.instant('FAIL'),
          text: this.translate.instant('PROFILE_COMPONENT_17'),
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        })
        return;

      }
      if (!userEmail || userEmail.length==0){
        Swal.fire({
          title: this.translate.instant('FAIL'),
          text: this.translate.instant('PROFILE_COMPONENT_18'),
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        })
        return;

      }
/*      if (!userPhone || userPhone.length==0){
        Swal.fire({
          title: this.translate.instant('FAIL'),
          text: "Por favor preencha seu telefone.",
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        })
        return;


      }
      try{
        let vecbirth=birthdate.split('/')
        let date=new Date();
        date.setDate(parseInt(vecbirth[0]));
        let month:number=parseInt(vecbirth[1])
        date.setMonth(month)
        date.setFullYear(parseInt(vecbirth[2]));
        this.user.birthdate=date.getTime();
        if (isNaN(this.user.birthdate)){
          this.user.birthdate=0;
        }
      }
      catch(err){
        this.user.birthdate=0;
      }
*/
      this.user.sex=this.gender;
      let isInComplete=this.isIncompleteProfile(this.user);
      if (isInComplete.length==0 && wasInComplete.length>0){
        this.user.vippoints=this.user.vippoints+100;
      }
      if (isInComplete.length>0 && wasInComplete.length==0){
        this.user.vippoints=this.user.vippoints-100;
      }

      if (instagram){
        let idx=instagram.indexOf('instagram.com');
        if (idx>=0){
          this.user.instagram=instagram;
        }
        else{
          this.user.instagram='https://www.instagram.com/'+instagram;
        }
      } else {
        this.user.instagram='';
      }
      if (linkedIn){
        let idx=linkedIn.indexOf('linkedin.com');
        if (idx>=0){
          this.user.linkedIn=linkedIn;
        }
        else{
          this.user.linkedIn='https://www.linkedin.com/in/'+linkedIn;
        }
      } else {
        this.user.linkedIn='';
      }



      this.finalizeUpdate();

  }

  public testInstagram(){
    let instagram:string = this.profileForm.controls['userInstagram'].value;
    if (instagram){
      let idx=instagram.indexOf('instagram.com');
      if (idx>=0){
        this.user.instagram=instagram;
      }
      else{
        this.user.instagram='https://www.instagram.com/'+instagram;
      }
    } else {
      this.user.instagram='';
    }
    window.open(this.user.instagram, '_blank');
    

  }
  public testLinkedIn(){
    let linkedIn:string = this.profileForm.controls['userLinkedIn'].value;
    if (linkedIn){
      let idx=linkedIn.indexOf('linkedin.com');
      if (idx>=0){
        this.user.linkedIn=linkedIn;
      }
      else{
        this.user.linkedIn='https://www.linkedin.com/in/'+linkedIn;
      }
    } else {
      this.user.linkedIn='';
    }

    window.open(this.user.linkedIn, '_blank');
  }
  public sendIframeMessage(messageKind){
       		const event = new CustomEvent('angularMessage',{detail:messageKind});
  		window.dispatchEvent(event);
  }
  public unlog(){
      this._appData.instagramUser=null;
      let company=new CompanyBean();
      let event=new EventBean();
      event.company=company;
      this._appData.event=event;
      this._appData.page=''
      localStorage.clear();
      $("#profileModal").modal('hide');
      window.location.href = "https://liveplanet.com.br";
    
  }
  public gotoAdmin(){
    this._router.navigate(['/userprofile/']) 
    $('#profileModal').modal('hide')

  }
  public openBag(){
    this._appData.object=null;
    $('#profileModal').modal('hide')
    $('#containerModal').modal('show')
    $('#containerModalClick').click();

  }
  public openSkills(){
    $('#profileModal').modal('hide')
    $('#skillsModal').modal('show')
    $('#skillsModalClick').click();

  }
  public finalizeUpdate(){
    this._companyService.updateProfile(this.user).then(res => {
      this._appData.instagramUser=this.user;
      localStorage.setItem('instagramUser',JSON.stringify(this._appData.instagramUser))
      Swal.fire({
          title: this.translate.instant('SUCCESS'),
          text: this.translate.instant('PROFILE_COMPONENT_19'),
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        }) 
        this._companyService.updateUserProperty("full_name",this.user.full_name,this._appData.instagramUser)
        this.sendIframeMessage({kind:'updateUserStatus',full_name:this.user.full_name});
        $('#loadingModal').modal('hide');
        $("#profileModal").modal('hide');
        if (this.user.avatar=='./assets/characters/h1.png' ){
            $('#noAvatarModal').modal('show');
            $('#redrawAvatar').click()
        }
        else{
          //se nao precisa ir pro avatar precisa botar no evento.
          if (this._appData.eventToGo){
            this.addToEvent();
          }

        }
    });          
  }
  public addToEvent(){
    let date=new Date();
    let milis=date.getTime();
    let event = this._appData.eventToGo;
    if (event.dateStart<milis && event.dateEnd>milis && event.gameEvent){
      this._companyService.addToEvent(this._appData.instagramUser.uid,event);         
    }
    else{
      let user=this._appData.instagramUser;
      this._companyService.addToLove(event,user).then((val)=>{
        Swal.fire(this.translate.instant('PROFILE_COMPONENT_20'),this.translate.instant('PROFILE_COMPONENT_21'))
        $("#updateEventUserList").click();
      })
    }
  }

 
  public indication(){
    $('#indicationModal').modal('show');
    var filename = location.pathname.match(/[^\/]+$/)[0]

    let code='';
    let indication=this._appData.instagramUser;


    if (indication){
      code=code+'?indication='+indication.uid;
    }
    let link='https://viplistas.com.br/userlogin'+code


    $('#copyLink').val(link);

  }
  public copyLink(){
      /* Select the text field */
    var copyText = $('#copyLink');
    copyText.select();
    try{
      copyText.setSelectionRange(0, 99999); /*For mobile devices*/
    }
    catch (err){}
    /* Copy the text inside the text field */
    document.execCommand("copy");
  }
  public updateUserImage(name: string) {
    this.imageStr = name;
    $('#userImageUpdate').click();
  }


  public userFileEvent(fileInput: any){
    var file = fileInput.target.files[0];
    let filename: string = file.name;
    let newfile = this.imageStr + filename;//.substr(idx,4);
    this._auth.uploadToFirebase(file, newfile, 'userprofile/'+this._appData.instagramUser.uid).subscribe(snapshot =>{
      snapshot.ref.getDownloadURL().then(url => {
        console.log(url);
        let finalURL = url;
        let found = false;
        this._appData.instagramUser.profile_picture=finalURL;
        this._appData.profilePicture=finalURL;
        this._companyService.updateUserProperty("profile_picture",finalURL,this._appData.instagramUser)
        let date=new Date();
        let time=date.getTime();
        let notification={
          subject:this._appData.instagramUser.uid,
          picture:finalURL,
          kind:'updateUserProfile',
          room:this._appData.room.id,
          date:time
        }
        this._companyService.addEventNotification(this._appData.event,notification)   
      })

    });
  }

  public userWavFileEvent(fileInput: any){
    var file = fileInput.target.files[0];
    let filename: string = file.name;
    let newfile = this.imageStr + filename;//.substr(idx,4);
    this._auth.uploadToFirebase(file, newfile, 'userprofile/'+this._appData.instagramUser.uid).subscribe(snapshot =>{
      snapshot.ref.getDownloadURL().then(url => {
        console.log(url);
        let finalURL = url;
        let found = false;
        this._appData.instagramUser.profile_picture=finalURL;
        this._appData.profilePicture=finalURL;
        this._companyService.updateUserProperty("profile_picture",finalURL,this._appData.instagramUser)
        let date=new Date();
        let time=date.getTime();
        let notification={
          subject:this._appData.instagramUser.uid,
          picture:finalURL,
          kind:'updateUserProfile',
          room:this._appData.room.id,
          date:time
        }
        this._companyService.addEventNotification(this._appData.event,notification)   
      })

    });
  }

  
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+easylogin/profile-modal/profile-component.ts